/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ZodiacGemini = [
  ["path", { d: "M16 4.525v14.948" }],
  ["path", { d: "M20 3A17 17 0 0 1 4 3" }],
  ["path", { d: "M4 21a17 17 0 0 1 16 0" }],
  ["path", { d: "M8 4.525v14.948" }]
];

export { ZodiacGemini as default };
//# sourceMappingURL=zodiac-gemini.js.map
